module.exports = __webpack_public_path__ + "img/aboutBg.3a9aaafe.png";